module.exports = __webpack_public_path__ + "static/media/session-detail-service.8e2e66fb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/session-detail-service.svg
// module id = 834
// module chunks = 1